import { useDeviceFingerprint } from '~/composables/apostatudo/use-device-fingerprint';
import { useUserJourney } from '~/composables/apostatudo/use-user-journey';
import { useMarketingTracking } from '~/composables/apostatudo/use-marketing-tracking';

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) {
    return;
  }

  const { ensureFingerprint } = useDeviceFingerprint();
  const { enterSiteEvent } = useUserJourney();
  const { persistFromQuery, watchCookies } = useMarketingTracking();

  watchCookies();

  queueMicrotask(async () => {
    try {
      persistFromQuery(to.query);
      await ensureFingerprint();
      await enterSiteEvent();
    } catch (error) {
      console.debug('[enter-site middleware] ignored error', error);
    }
  });
});
